import { useEffect, useState } from "react";
import getSliders from "../Services/requests/getSliders";
import usePopupCtx from "./usePopupCtx";

const useGetSliders = (withBanner) => {
	const [loading, setLoading] = useState(true);
	const [sliders, setSliders] = useState([]);
	const popUpCtx = usePopupCtx();

	useEffect(() => {
		if (withBanner) {
			if (!loading) {
				setLoading(true);
			}

			getSliders()
				.then((slider) => {
					setLoading(false);
					return setSliders((prev) => [...prev, ...slider]);
				})
				.catch((e) =>
					popUpCtx.showPopUp({
						message: `Ha ocurrido un error al obtener los sliders, intente más tarde`,
					})
				);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [withBanner]);

	return { loading, sliders };
};

export default useGetSliders;
